const UpdatedButton = () => {
   return (
    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.22901 9.06248L0.708008 5.52148L1.75001 4.47948L4.22901 6.93848L10.25 0.938477L11.292 2.00048L4.22901 9.06248Z" fill="white"/>
    </svg>
    
     
   )
}
export default UpdatedButton;